export function getArtworkUri(defaultArtworkUri: string, trackArtworkUri: string | undefined, alwaysUseDefaultArtwork: boolean): string {
  if (alwaysUseDefaultArtwork || !trackArtworkUri) return defaultArtworkUri;

  return trackArtworkUri;
}
